package com.devi3east.bashbuddy.favorites.ui

import com.devi3east.bashbuddy.features.events.common.data.models.Event

data class FavoriteEventsUiState(
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val eventsList: List<Event> = emptyList()
)
